module.exports = __webpack_public_path__ + "static/media/pfBackground.c896cb19.jpg";